import * as actionTypes from '../constants/userActionTypes';
import * as api from '../api';
import { toast } from "react-toastify";

/**
* function for loadObjectives
* @param {*} data User data 
* @description get user infromation
* @param {function} loadObjectives loadObjectives function
*/
export const loadObjectives = id => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_REQUEST })
        const { data } = await api.editObjectives(id);
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_SUCCESS, payload: data })

    } catch (err) {
        console.log(err)
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_FAIL, payload: err.response.data })
    }
}

/**
* function for user register
* @param {*} data form data and history
* @description user register
* @param {function} register register function
*/
export const updateObjectivesOwnersAndApprovers = (formData, history) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_REQUEST })
        const { data } = await api.updateObjectives(formData);
        toast.success(data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_SUCCESS, payload: data })

    } catch (err) {
        console.log('error is: ', err.response?.data)
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_FAIL, payload: err.response?.data?.message })
    }
}

export const updateObjectivesApprover = (id) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_REQUEST })
        const { data } = await api.updateObjectivesApprove(id);
        toast.success(data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_SUCCESS, payload: data })

    } catch (err) {
        console.log('error is: ', err.response?.data)
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_FAIL, payload: err.response?.data?.message })
    }
}

/**
* function for user update PROJECT_OBJECTIVES
* @param {*} data User data 
* @description update user infromation
* @param {function} updatePROJECT_OBJECTIVES updatePROJECT_OBJECTIVES function
*/
export const updateOwnerObjectives = formData => async (dispatch, getState) => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_REQUEST })
        const { data } = await api.updateOwnerObjectives(formData)
        toast.success(data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_SUCCESS, payload: data })
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_FAIL, payload: err.response.data.message })
    }
}

export const objectivesRejectedByApprover = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_REQUEST })
        const { data } = await api.rejectObjectives(formData)
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_SUCCESS, payload: data })
        toast.success(data.message);
    } catch (err) {
        console.log(err)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_OBJECTIVES_FAIL, payload: err.response.data.message })
    }
}

/**
* function for user update PROJECT_OBJECTIVES
* @param {*} data User data 
* @description update user infromation
* @param {function} sendUpdateObjectiveRequestByOwners sendUpdateObjectiveRequestByOwners function
*/
export const sendUpdateObjectiveRequestByOwners = projectId => async (dispatch, getState) => {
    try {
        const { data } = await api.requestObjectivesEdit(projectId)
        toast.success(data.message);
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
    }
}

/**
* function for user update acceptObjectiveUpdateRequestByUser
* @param {*} data User data 
* @description update user infromation
* @param {function} acceptObjectiveUpdateRequestByUser acceptObjectiveUpdateRequestByUser function
*/
export const requestAcceptObjectievEdit = (formData, history) => async (dispatch, getState) => {
    try {
        const { data } = await api.requestAcceptObjectievEdit(formData)
        toast.success(data.message);
        history.push('/')
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
    }
}